// extracted by mini-css-extract-plugin
export default {"menuUserLabelUser":"CommunicationCentreCounter_menuUserLabelUser__ztvWD","menuCommunicationCentre":"CommunicationCentreCounter_menuCommunicationCentre__0V0em"};